# This module provides a "safer" interface to localStorage and sessionStorage
# (and any other storages that might arise in the future) that will work if
# you're in a browser that doesn't support that storage mechanism, or refuses
# to comply with it (for example, Safari in private browsing mode does not
# allow access to localStorage; browsers impose storage limits and throw when
# they're hit).
#
# It also exposes an interface that operates on JSON values instead of raw
# strings, and will catch parsing errors.

module.exports = (_storage) ->
  enabled: ->
    _storage?

  set: (name, value) ->
    try
      _storage?[name] = JSON.stringify(value)

  get: (name) ->
    s = @getRaw(name)
    if s
      try
        JSON.parse(s)
      catch ex
        null
    else
      null

  getRaw: (name) ->
    _storage?[name]

  unset: (name) ->
    if @getRaw(name)?
      delete _storage?[name]



// WEBPACK FOOTER //
// ./app/scripts/lib/storage-factory.coffee